import { useCallback } from 'react'
import { WrapperContainer, Modal, WrapperTeste, GridTeacher } from './styles'
import { AiOutlineClose } from 'react-icons/ai'

interface TitleProps {
  professores: any[]
  close(): void
}

const ModalTeacher: React.FC<TitleProps> = ({ professores, close }) => {
  const teste = (e) => {
    if (e.target.id === 'modal') closeModal()
  }

  const closeModal = useCallback(() => {
    close()
  }, [close])

  return (
    <WrapperContainer id="modal" onClick={teste}>
      <Modal>
        <WrapperTeste>
          <h2>Lista de professores</h2>
          <button onClick={closeModal}>
            <AiOutlineClose size={25} />
          </button>
        </WrapperTeste>
        <hr />
        <GridTeacher>
          {(professores || []).map((item, idx) => (
            <div key={idx} className="teacher_photo">
              <div className="name_photo">
                <img
                  src={
                    item?.image ??
                    `https://ui-avatars.com/api/?name=${item.name}&=rounded=true&background=ff6600&color=FFF`
                  }
                  alt={item.name}
                />
                <h4>Prof. {item.name}</h4>
              </div>
            </div>
          ))}
        </GridTeacher>
        <hr id="line-one" />
      </Modal>
    </WrapperContainer>
  )
}

export default ModalTeacher
